import { render } from "./AdvertisingMix.vue?vue&type=template&id=2cecb755&scoped=true"
import script from "./AdvertisingMix.vue?vue&type=script&lang=js"
export * from "./AdvertisingMix.vue?vue&type=script&lang=js"

import "./AdvertisingMix.vue?vue&type=style&index=0&id=2cecb755&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cecb755"]])

export default __exports__